import { Button, Col, Modal, Row, Typography } from "antd";
import { useState } from "react";
import SaasPE from "@assets/SVG/logo.svg";
import styles from "../Auth.module.scss";
import { imageKey, mediaHost, orgName, reactAuthFlow, supportEmail } from "~/Utils";

interface Props {
  openModal: boolean;
  consentURL: string;
  setOpenModal: (value: boolean) => void;
  active: boolean;
}
export const UserConsent = ({ openModal, setOpenModal, consentURL, active }: Props) => {
  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Modal
      open={openModal}
      closable={reactAuthFlow === "BOTH" && true}
      footer={null}
      onCancel={handleClose}
    >
      {active ? (
        <Row style={{ display: "block" }}>
          <Col style={{ paddingTop: styles.whitespace2, textAlign: "center" }}>
            <img
              src={`${mediaHost}/images/branding/logo.png${imageKey}`}
              alt={orgName}
              style={{maxWidth: 220}}
            />
          </Col>
          <Col style={{ paddingTop: styles.whitespace3, margin: styles.whitespaceAuto, textAlign: "center" }}>
            <Typography.Title level={5}>Docusign - User Consent Required</Typography.Title>
          </Col>
          <Col>
            <ul
              style={{
                paddingTop: styles.whitespace3,
                color: styles.black,
                fontWeight: styles.fontWeight5,
                margin: styles.whitespaceAuto,
              }}
            >
              <li>
                Thank you for choosing {orgName} SPA. Your account has been activated successfully.
              </li>
              <li>
                Please provide your consent by clicking the "Grant Consent" button below.
              </li>
              <li>
              If you have any queries, please reach out to us at&nbsp;
                <a href={`mailto:${supportEmail}`}>{supportEmail}.</a>
              </li>
            </ul>
          </Col>
          <Col
            span={24}
            style={{ paddingTop: styles.whitespace3 }}
          >
            <Button
              className="w-100"
              onClick={() => {
                window.open(consentURL);
              }}
              type="primary"
            >
              Grant Consent
            </Button>
          </Col>
        </Row>
      ) : (
        <Row style={{ display: "block" }}>
          <Col style={{ paddingTop: styles.whitespace2, textAlign: "center" }}>
            <img
              src={`${mediaHost}/images/branding/logo.png${imageKey}`}
              alt={orgName}
              style={{maxWidth: 220}}
            />
          </Col>
          <Col style={{ paddingTop: styles.whitespace3, margin: styles.whitespaceAuto, textAlign: "center" }}>
            <Typography.Title level={5}>Docusign - Account activation required</Typography.Title>
          </Col>
          <Col>
            <ul
              style={{
                paddingTop: styles.whitespace3,
                color: styles.black,
                fontWeight: styles.fontWeight5,
                margin: styles.whitespaceAuto,
              }}
            >
              <li>
                Thank you for choosing {orgName} SPA. As part of the onboarding process, a DocuSign user account has
                been created.
              </li>
              <li>We have sent an account activation email. Kindly follow the procedure outlined in the email.</li>
              <li>
              If you have any queries, please reach out to us at&nbsp;
                <a href={`mailto:${supportEmail}`}>{supportEmail}.</a>
              </li>
            </ul>
          </Col>
          <Col
            span={24}
            style={{ paddingTop: styles.whitespace3 }}
          >
            <Button
              className="w-100"
              onClick={() => {
                handleClose();
              }}
              type="primary"
            >
              Close
            </Button>
          </Col>
        </Row>
      )}
    </Modal>
  );
};
